import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AgentWinLossReport from './AgentWinLossReport';
import BettingRecords from './BettingRecords';

const Reports = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="agent-win-loss" />} />
      <Route path="agent-win-loss" element={<AgentWinLossReport />} />
      <Route path="betting-records" element={<BettingRecords />} />
    </Routes>
  );
};

export default Reports;